import { type History, HistoryEntryTypeEnum } from "@repo/api";

import { type HistoryGroup } from "../history/utils";

export const MIN_NOTE_LENGTH = 3;
export const MAX_NOTE_LENGTH = 1500;

export const isNoteEntry = (entry: History | HistoryGroup): boolean => {
  return (
    entry.entryType === HistoryEntryTypeEnum.CUSTOM_NOTES ||
    entry.entryType === HistoryEntryTypeEnum.REMARK_UPDATE ||
    entry.entryType === HistoryEntryTypeEnum.CUSTOMER_CALLED_IN ||
    entry.entryType === HistoryEntryTypeEnum.CALLED_THE_CUSTOMER ||
    entry.entryType === HistoryEntryTypeEnum.WALK_IN_CUSTOMER ||
    entry.entryType === HistoryEntryTypeEnum.CUSTOMER_EMAILED
  );
};

export const isDeletedNoteEntry = (entry: History | HistoryGroup): boolean => {
  return (
    entry.entryType === HistoryEntryTypeEnum.CUSTOM_NOTES &&
    entry.isDeleted === true
  );
};

export interface DeletedNote {
  id: string;
  note: string;
  deletedBy: string;
  deletedAt: string;
}
